import React, { FC } from "react";
import styled from "styled-components";
import { Typography } from "@atoms/typography";
import { useFHConfig } from "@templates/config";
import Button from "@atoms/button";

export interface IntroductionData {
  top_title: string;
  top_subtitle: string;
  top_image: string;
  top_description: string;
}

export interface IntroductionProps {
  introductionData: IntroductionData;
  scrollToForm?: () => void;
  scrollToButtonLabel?: string;
}

export const Introduction: FC<IntroductionProps> = ({ introductionData, scrollToForm, scrollToButtonLabel }) => {
  const config = useFHConfig();
  return (
    <IntroductionWrapper>
      <TextColumn>
        <Typography variant="title1">{introductionData.top_title}</Typography>

        <Typography as="p" variant="body1">
          {introductionData.top_description}
        </Typography>

        <Typography as="p" variant="body1" bold>
          {introductionData.top_subtitle}
        </Typography>
        <ButtonContainer>
          <Button variant="primary" onClick={scrollToForm}>
            {scrollToButtonLabel}
          </Button>
        </ButtonContainer>
      </TextColumn>

      <ImageColumn>
        <Image src={`${config.backUrl}/assets/${introductionData.top_image}`} alt="Professional property management" />
      </ImageColumn>
    </IntroductionWrapper>
  );
};

const IntroductionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 40px 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: stretch;
  }
`;

const TextColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
`;

const ImageColumn = styled.div`
  flex: 1;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media (max-width: 767px) {
    height: 300px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;
